import type { ICustomControlRequestReadProps } from '../pages/customControls/interfaces/customControlRequestReadProps';
import { translateKey } from '../../translate';
import { FormParagraph } from './common';
import { FormLabel } from './forms/FormLabel';
import { HorizontalFormGroupRead } from './forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from './forms/InputContainer';

export function CareProviderContactRead(props: ICustomControlRequestReadProps) {
    const contactData = props.request.customControlData.contactgegevens_specialist;
    if (!contactData || (!contactData.phoneNumber && !contactData.emailAddress)) {
        return null;
    }

    return (
        <>
            {contactData?.phoneNumber && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('request.phoneNumberRequester')}</FormLabel>
                    <InputContainer>
                        <FormParagraph>{contactData.phoneNumber}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {contactData?.emailAddress && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('patient.emailForContact')}</FormLabel>
                    <InputContainer>
                        <FormParagraph>{contactData.emailAddress}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
